(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-basket/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-basket/assets/javascripts/init-box.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_basket = svs.themes.sport_basket || {};

  svs.themes.sport_basket.initStatusStart = function (data) {
    if (svs.themes.sport_basket.isLive(data.status.id)) {
      if (data.status.id === 1) {
        return '<div class="brick match-status brick-active f-condensed align-center">H1</div>';
      }

      if (data.status.id === 2) {
        return '<div class="brick match-status brick-active f-condensed align-center">H2</div>';
      }

      if (data.status.id === 37) {
        return '<div class="brick match-status brick-active f-condensed align-center">Q1</div>';
      }

      if (data.status.id === 38) {
        return '<div class="brick match-status brick-active f-condensed align-center">Q2</div>';
      }

      if (data.status.id === 39) {
        return '<div class="brick match-status brick-active f-condensed align-center">Q3</div>';
      }

      if (data.status.id === 40) {
        return '<div class="brick match-status brick-active f-condensed align-center">Q4</div>';
      }

      if (data.status.id === 19) {
        return '<div class="brick match-status brick-active f-condensed align-center">ÖT</div>';
      }

      if (data.status.id === 22) {
        return '<div class="brick match-status brick-active f-condensed align-center">STR</div>';
      }

      if (data.status.id === 14 || data.status.id === 16
      || data.status.id === 18
      ) {
          return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
        }

      return '<div class="brick match-status brick-active f-condensed align-center">Q1</div>';
    } else if (svs.themes.sport_basket.isEnded(data.status.id)) {
      if (data.status.id === 32) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">ÖT</div>';
      }

      if (data.status.id === 33) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">STR</div>';
      }

      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">FT</div>';
    } else if (data.startTime) {
      return "<div class=\"brick match-status brick-border f-condensed align-center\">".concat(svs.themes.formatTime(data.startTime), "</div>");
    }

    return '';
  };


  svs.themes.sport_basket.hasMatchMinutes = function () {
    return false;
  };
})(svs);
 })(window);